import { UserKind } from "01Data/Account";
import { AppContext } from "01Data/AppData";
import Footer from "03AdminPages/99Parts/Footer";
import Header from "03AdminPages/99Parts/Header";
import SideBar from "03AdminPages/99Parts/SideBar";
import { styled, Typography, TypographyProps } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";

const PageTitle = styled(Typography)<
  TypographyProps<"h2", { component: "h2" }>
>(({ theme }) => ({
  fontSize: "1.6rem",
  color: theme.palette.grey[800],
  marginBottom: theme.spacing(2),
}));

const AppBarSpacer = styled("div")(({ theme }) => ({
  appBarSpacer: theme.mixins.toolbar,
}));

const Content = styled("main")(({ theme }) => ({
  height: "100vh",
  overflow: "auto",
  paddingTop: theme.spacing(12),
  paddingBottom: theme.spacing(4),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

type Props = {
  children: any;
  title: string;
};

/*
        <PageTitle component="h2" variant="h5" color="inherit" noWrap>{props.title}</PageTitle>

*/
const PageTemplate = (props: Props) => {
  const a = useContext(AppContext).account;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const IsQualifiedUser = (kind: UserKind) => {
    switch (kind) {
      case "super_administrator":
        return true;
      default:
        return false;
    }
  };

  useEffect(() => {
    a.IsLogin(IsQualifiedUser).catch((err: any) => {
      console.log("資格情報エラー");
      console.error(err);
      navigate("/login/");
    });
  }, [a, navigate]);

  return (
    <>
      <Header open={open} setOpen={setOpen} />
      <SideBar open={open} setOpen={setOpen} />
      <Content>
        <AppBarSpacer />
        <PageTitle component="h2" variant="h5" color="inherit" noWrap>
          {props.title}
        </PageTitle>
        {props.children}
      </Content>
      <Footer />
    </>
  );
};

export default PageTemplate;
